// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"347":"28c0cbfc","526":"8330bb16"}[chunkId] + ".chunk.css";
};